import type { UseQueryOptions } from '@tanstack/vue-query';
import { useQuery } from '@tanstack/vue-query';
import type { MaybeRef } from '@vueuse/core';
import { computed, unref } from 'vue';
import { myDocumentsKeys } from '../my-documents-key-factory';
import { MyDocumentsService } from '../service/my-documents.service';

export const useMyDocumentsToken = (
  userId: MaybeRef<string>,
  options?: Partial<UseQueryOptions<string>>
) =>
  useQuery({
    ...options,
    queryKey: computed(() => myDocumentsKeys.token(unref(userId))),
    queryFn: () => MyDocumentsService.getToken(),
  });
